module.exports = __webpack_public_path__ + "static/media/godelectro.4f170d60.svg";